/**
 * Opções do site ligadas/desligadas em Configurações > Opções do site (prop compartilhada
 * `configuracaoSite`). Opção ainda não salva vale como ligada, como no servidor.
 */

/** Atalhos da barra de acessibilidade, na ordem em que aparecem. */
export const ATALHOS_DA_BARRA = ['barra_mais_transparencia', 'barra_contraste', 'barra_mapa_site', 'barra_area_servidor']

export const opcaoLigada = (configuracao, chave) => configuracao?.[chave] ?? true

/** A barra aparece se estiver ligada e tiver pelo menos um atalho ligado (sem faixa vazia). */
export const barraAcessibilidadeVisivel = (configuracao) => opcaoLigada(configuracao, 'barra_acessibilidade')
    && ATALHOS_DA_BARRA.some(chave => opcaoLigada(configuracao, chave))
